import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  TextField,
  Typography,
  Checkbox,
  Paper,
  TableHead,
  TableRow,
  TableCell,
  InputAdornment,
  Tooltip,
  IconButton,
  MenuItem,
  Grid,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers";
import useOrdersAdmin from "../../../hooks/useOrdersAdmin";
import { AuthContext } from "../../../context/AuthContext";
import SearchBar from "../../../components/SearchBar";
import ListFooter from "../../../components/InfiniteScroller/ListFooter";
import InfiniteScrollerTable from "../../../components/InfiniteScroller/InfiniteScrollerTable";
import CachedIcon from "@mui/icons-material/Cached";
import { useTheme } from "@emotion/react";
import { useParams } from "react-router-dom";
import {
  toTwoDecimals,
  toThreeDecimals,
} from "../../../components/NewDetail/calculations/utils";
import { useFormik } from "formik";
import * as Yup from "yup";
import MaterialSummary from "../Quotes/Quote/QuoteDetails/MaterialSummary";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"; // ES 2015
import timezone from "dayjs/plugin/timezone"; // ES 2015
import isoWeek from "dayjs/plugin/isoWeek"; // ES 2015
import getMaterialSummaryData from "../../../service/materialSummaryService";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);
const DEFAULT_TIMEZONE = "America/Phoenix";
dayjs.tz.setDefault(DEFAULT_TIMEZONE);

const PurchaseOrderForm = ({ existingPurchaseOrder, onSubmit, disabled }) => {
  const theme = useTheme();
  const { orderId } = useParams();

  const { authToken, ezorder } = useContext(AuthContext);
  const [
    searchQuery,
    setSearchQuery,
    orders,
    onRefresh,
    refreshing,
    onLoadMore,
    loadingMore,
    total,
    hasMore,
  ] = useOrdersAdmin(authToken, 10);

  const getOrderDetails = async (id) => {
    try {
      const response = await ezorder.get(`/admin/orders/${id}`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200 || response.status == 201) {
        return response.data.order;
      } else {
        return null;
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const onOrderSelect = async (order) => {
    let orderFullDetails = await getOrderDetails(order.id);
    let materialsNeeded = getMaterialSummaryData(orderFullDetails);
    let {
      flatsNeeded,
      standaloneFlats,
      galvFlatsNeeded,
      // OTHER
      color,
      gauge,
      manufacturer,
      // coil,
      coilDropLF,
      coilDropSF,
      coilDropTotalPrice,
      panelCoilDrop,
      linealFeetOfCoilWithWaste,
      squareFeetOfCoilNeededWithWaste,
      masterCoilSizeNeeded,
      coilSizeNeeded,
      coilPricePerSF,
      panelMaterialCost,
      //
      // flatsNeeded,
      flatSheetSize,
      flatSheetCost,
      //
      // galvFlatsNeeded,
      galvFlatSheetCost,
      galvFlatSheetGauge,
      galvFlatSheetSize,
    } = materialsNeeded;

    console.log(galvFlatSheetGauge);

    formik.setValues((prev) => ({
      ...prev,
      order: orderFullDetails,
      // Extract Order Numbers
      // Painted Flat Sheets
      color: color, // setColor(materialsNeeded.color);
      gauge: gauge, // setGauge(materialsNeeded.gauge);
      flatSheetQuantity: flatsNeeded + standaloneFlats, // materialsNeeded.flatsNeeded.quantity, // setFlatSheetQuantity(materialsNeeded.flatsNeeded.quantity);
      flatSheetSizeInches: flatSheetSize, // setFlatSheetSizeInches(materialsNeeded.flatsNeeded.size);
      pricePerFlatSheet: flatSheetCost, // setPricePerFlatSheet(materialsNeeded.flatsNeeded.pricePerFS);
      flatSheetTotalPrice: (flatsNeeded + standaloneFlats) * flatSheetCost, // setFlatSheetTotalPrice(materialsNeeded.flatsNeeded.quantity * materialsNeeded.flatsNeeded.pricePerFS);

      // Galvanized Flat Sheets
      galvanizedFlatSheetGauge: !galvFlatSheetGauge ? 0 : galvFlatSheetGauge, // setGalvanizedFlatSheetGauge(materialsNeeded.galvFlatsNeeded.gauge); // here
      galvanizedFlatSheetQuantity: galvFlatsNeeded, // materialsNeeded.galvFlatsNeeded.quantity, // setGalvanizedFlatSheetQuantity(materialsNeeded.galvFlatsNeeded.quantity);
      galvanizedFlatSheetSizeInches: galvFlatSheetSize, // setGalvanizedFlatSheetSizeInches(materialsNeeded.galvFlatsNeeded.size);
      pricePerGalvanizedFlatSheet: galvFlatSheetCost, // setPricePerGalvanizedFlatSheet(materialsNeeded.galvFlatsNeeded.pricePerFS);
      galvanizedFlatSheetTotalPrice: galvFlatsNeeded * galvFlatSheetCost, // setGalvanizedFlatSheetTotalPrice(materialsNeeded.galvFlatsNeeded.quantity *materialsNeeded.galvFlatsNeeded.pricePerFS);

      // Coil (Panel)
      linealFeetOfCoil: linealFeetOfCoilWithWaste, // setLinealFeetOfCoil(materialsNeeded.coil.linealFeetOfCoilWithWaste);
      squareFeetOfCoil: squareFeetOfCoilNeededWithWaste, // setSquareFeetOfCoil(materialsNeeded.coil.squareFeetOfCoilNeededWithWaste);
      masterCoilWidthInches: masterCoilSizeNeeded, // setMasterCoilWidthInches(materialsNeeded.coil.masterCoilSizeNeeded);
      coilWidthInches: coilSizeNeeded, // setCoilWidthInches(materialsNeeded.coil.coilSizeNeeded);
      pricePerSquareFeetOfCoil: coilPricePerSF, // setPricePerSquareFeetOfCoil(materialsNeeded.coil.coilPricePerSF);
      coilTotalPrice: panelMaterialCost, // setCoilTotalPrice();

      // Coil Drop (Panel)
      coilDropWidthInches: panelCoilDrop, // setCoilDropWidthInches(materialsNeeded.coil.coilDrop);
      linealFeetOfCoilDrop: coilDropLF, // setLinealFeetOfCoilDrop(materialsNeeded.coil.dropLF);
      squareFeetOfCoilDrop: coilDropSF, // setSquareFeetOfCoilDrop(materialsNeeded.coil.dropSF);
      coilDropTotalPrice: coilDropTotalPrice, // setCoilDropTotalPrice(materialsNeeded.coil.coilDropTotalPrice);
    }));
  };

  const loadPreSelectedOrder = async (orderId) => {
    const response = await ezorder
      .get(`/admin/orders/${orderId}`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .catch((error) => {
        throw Error("Unable to load order", { cause: error });
      });
    onOrderSelect(response.data.order);
  };

  const formValidationSchema = Yup.object({
    // description: Yup.string().required("description required"),
    // uom: Yup.string().required("Unit of Measure Requried"),
    // retailPrice: Yup.number()
    //   .positive("Please enter positive number")
    //   .required("Retail Price Required"),
  });

  const formik = useFormik({
    enableReinitialize: false,
    initialValues: {
      order: existingPurchaseOrder ? existingPurchaseOrder.order : null,
      issueDate:
        existingPurchaseOrder && existingPurchaseOrder.issueDate
          ? dayjs(existingPurchaseOrder.issueDate).tz(DEFAULT_TIMEZONE)
          : null,
      deliveryType: existingPurchaseOrder
        ? existingPurchaseOrder.deliveryType
        : "Delivery",
      shippingAddress: existingPurchaseOrder
        ? existingPurchaseOrder.shippingAddress
        : "1146 W. Hilton Ave., Phoenix, AZ 85007",
      vendor: existingPurchaseOrder ? existingPurchaseOrder.vendor : "",
      contact: existingPurchaseOrder ? existingPurchaseOrder.contact : "",
      materialReceiveLocation: existingPurchaseOrder
        ? existingPurchaseOrder.materialReceiveLocation
        : "",
      status: existingPurchaseOrder ? existingPurchaseOrder.status : "",
      dateReceived:
        existingPurchaseOrder && existingPurchaseOrder.dateReceived
          ? dayjs(existingPurchaseOrder.dateReceived).tz(DEFAULT_TIMEZONE)
          : null,
      notes: existingPurchaseOrder ? existingPurchaseOrder.notes : "",

      // Extract Order Numbers
      // Painted Flat Sheets
      color: existingPurchaseOrder ? existingPurchaseOrder.color : "", // setColor(materialsNeeded.color);
      gauge: existingPurchaseOrder ? existingPurchaseOrder.gauge : "", // setGauge(materialsNeeded.gauge);
      flatSheetQuantity: existingPurchaseOrder
        ? existingPurchaseOrder.flatSheetQuantity
        : 0, // setFlatSheetQuantity(materialsNeeded.flatsNeeded.quantity);
      flatSheetSizeInches: existingPurchaseOrder
        ? existingPurchaseOrder.flatSheetSizeInches
        : 0, // setFlatSheetSizeInches(materialsNeeded.flatsNeeded.size);
      pricePerFlatSheet: existingPurchaseOrder
        ? existingPurchaseOrder.pricePerFlatSheet
        : 0, // setPricePerFlatSheet(materialsNeeded.flatsNeeded.pricePerFS);
      flatSheetTotalPrice: existingPurchaseOrder
        ? existingPurchaseOrder.flatSheetTotalPrice
        : 0, // setFlatSheetTotalPrice(materialsNeeded.flatsNeeded.quantity * materialsNeeded.flatsNeeded.pricePerFS);

      // Galvanized Flat Sheets
      galvanizedFlatSheetGauge:
        existingPurchaseOrder && existingPurchaseOrder.galvanizedFlatSheetGauge
          ? existingPurchaseOrder.galvanizedFlatSheetGauge
          : 0, // setGalvanizedFlatSheetGauge(materialsNeeded.galvFlatsNeeded.gauge); // here
      galvanizedFlatSheetQuantity: existingPurchaseOrder
        ? existingPurchaseOrder.galvanizedFlatSheetQuantity
        : 0, // setGalvanizedFlatSheetQuantity(materialsNeeded.galvFlatsNeeded.quantity);
      galvanizedFlatSheetSizeInches: existingPurchaseOrder
        ? existingPurchaseOrder.galvanizedFlatSheetSizeInches
        : 0, // setGalvanizedFlatSheetSizeInches(materialsNeeded.galvFlatsNeeded.size);
      pricePerGalvanizedFlatSheet: existingPurchaseOrder
        ? existingPurchaseOrder.pricePerGalvanizedFlatSheet
        : 0, // setPricePerGalvanizedFlatSheet(materialsNeeded.galvFlatsNeeded.pricePerFS);
      galvanizedFlatSheetTotalPrice: existingPurchaseOrder
        ? existingPurchaseOrder.galvanizedFlatSheetTotalPrice
        : 0, // setGalvanizedFlatSheetTotalPrice(materialsNeeded.galvFlatsNeeded.quantity *materialsNeeded.galvFlatsNeeded.pricePerFS);

      // Coil (Panel)
      linealFeetOfCoil: existingPurchaseOrder
        ? existingPurchaseOrder.linealFeetOfCoil
        : 0, // setLinealFeetOfCoil(materialsNeeded.coil.linealFeetOfCoilWithWaste);
      squareFeetOfCoil: existingPurchaseOrder
        ? existingPurchaseOrder.squareFeetOfCoil
        : 0, // setSquareFeetOfCoil(materialsNeeded.coil.squareFeetOfCoilNeededWithWaste);
      masterCoilWidthInches: existingPurchaseOrder
        ? existingPurchaseOrder.masterCoilWidthInches
        : 0, // setMasterCoilWidthInches(materialsNeeded.coil.masterCoilSizeNeeded);
      coilWidthInches: existingPurchaseOrder
        ? existingPurchaseOrder.coilWidthInches
        : 0, // setCoilWidthInches(materialsNeeded.coil.coilSizeNeeded);
      pricePerSquareFeetOfCoil: existingPurchaseOrder
        ? existingPurchaseOrder.pricePerSquareFeetOfCoil
        : 0, // setPricePerSquareFeetOfCoil(materialsNeeded.coil.coilPricePerSF);
      coilTotalPrice: existingPurchaseOrder
        ? existingPurchaseOrder.coilTotalPrice
        : 0, // setCoilTotalPrice(materialsNeeded.coil.materialCost);

      // Coil Drop (Panel)
      coilDropWidthInches: existingPurchaseOrder
        ? existingPurchaseOrder.coilDropWidthInches
        : 0, // setCoilDropWidthInches(materialsNeeded.coil.coilDrop);
      linealFeetOfCoilDrop: existingPurchaseOrder
        ? existingPurchaseOrder.linealFeetOfCoilDrop
        : 0, // setLinealFeetOfCoilDrop(materialsNeeded.coil.dropLF);
      squareFeetOfCoilDrop: existingPurchaseOrder
        ? existingPurchaseOrder.squareFeetOfCoilDrop
        : 0, // setSquareFeetOfCoilDrop(materialsNeeded.coil.dropSF);
      coilDropTotalPrice: existingPurchaseOrder
        ? existingPurchaseOrder.coilDropTotalPrice
        : 0, // setCoilDropTotalPrice(materialsNeeded.coil.coilDropTotalPrice);
    },
    validationSchema: formValidationSchema,
    validateOnBlur: false,
    validateOnChange: true,
    onSubmit: (values) => {
      if (existingPurchaseOrder) {
        let poUpdate = {
          ...existingPurchaseOrder,
          ...values,
        };
        console.log("UPDATE PURCHASE ORDER", poUpdate);
        onSubmit(poUpdate);
      } else {
        console.log("CREATE NEW PURCHASE ORDER", values);
        onSubmit(values);
      }
    },
  });

  // This is if the order/job id is in the URL?? Where is this activated?
  useEffect(() => {
    if (orderId) {
      loadPreSelectedOrder(orderId);
    }
  }, [orderId]);

  return (
    <Box>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Box style={{ padding: 16 }}>
          <Box>
            <Typography>Job Details</Typography>
            <Box sx={{ padding: "16px" }}>
              <Box>
                {formik.values.order ? (
                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                    <TextField
                      size="small"
                      fullWidth
                      sx={{ marginTop: "16px" }}
                      InputProps={{
                        readOnly: true,
                        disableUnderline: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <Tooltip title="reset">
                              <IconButton
                                disabled={disabled}
                                onClick={() => {
                                  formik.setFieldValue("order", null);
                                }}
                              >
                                <CachedIcon
                                  color="tertiary"
                                  sx={{ marginLeft: 0, marginRight: 0 }}
                                />
                              </IconButton>
                            </Tooltip>
                          </InputAdornment>
                        ),
                      }}
                      label="For Industry Order - Order ID | PO Number | Status"
                      value={`${formik.values.order.id} | ${
                        formik.values.order.poNumber
                      } | ${
                        formik.values.order.orderStatus &&
                        formik.values.order.orderStatus.description
                          ? formik.values.order.orderStatus.description
                          : ""
                      }`}
                    />
                    <Button
                      onClick={() => {
                        window.open(
                          `${window.location.origin}/orders/${formik.values.order.id}`,
                          "_blank",
                          "noreferrer"
                        );
                      }}
                    >
                      View Order Details
                    </Button>
                  </Box>
                ) : (
                  <Box
                    style={{
                      paddingLeft: 48,
                      paddingRight: 48,
                      paddingTop: 16,
                      paddingBottom: 16,
                    }}
                  >
                    <Typography>
                      Select Industry Job for this Vendor PO
                    </Typography>
                    <SearchBar
                      label="Search Jobs"
                      searchQuery={searchQuery}
                      setSearchQuery={setSearchQuery}
                    />
                    <InfiniteScrollerTable
                      TableContainerComponent={Paper}
                      tableContainerStyle={{
                        maxHeight: "250px",
                        minHeight: "100px",
                      }}
                      tableStyle={{ minWidth: "600px", minHeight: "70px" }}
                      TableHead={() => (
                        <TableHead>
                          <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>Customer Name</TableCell>
                            <TableCell>Project</TableCell>
                            <TableCell>PO #</TableCell>
                            <TableCell>Credit Type</TableCell>
                            <TableCell>Date Approved</TableCell>
                            <TableCell>$</TableCell>
                          </TableRow>
                        </TableHead>
                      )}
                      items={orders}
                      renderRow={(item, index) => {
                        return (
                          <TableRow
                            key={index}
                            onClick={() => {
                              onOrderSelect(item);
                            }}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell>{item.id}</TableCell>
                            <TableCell>{item.company.name}</TableCell>
                            <TableCell>{item.project.name}</TableCell>
                            <TableCell>{item.poNumber}</TableCell>
                            <TableCell>{item.company.creditType}</TableCell>
                            <TableCell>
                              {dayjs(item.estimateApprovalDate)
                                .tz(DEFAULT_TIMEZONE)
                                .format("MM/DD/YY")}
                            </TableCell>
                            <TableCell>
                              ${toTwoDecimals(item.outTheDoorCost)}
                            </TableCell>
                          </TableRow>
                        );
                      }}
                      onRefresh={onRefresh}
                      onEndReached={onLoadMore}
                      loading={refreshing || loadingMore}
                      ListFooterComponent={() => {
                        return (
                          <ListFooter
                            hasMore={hasMore}
                            onClick={onLoadMore}
                            noMoreText={"End Reached"}
                          />
                        );
                      }}
                    />
                  </Box>
                )}
              </Box>
              {formik.values.order && formik.values.order.items && (
                <Box
                  sx={{
                    marginTop: "8px",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    width: "700px",
                  }}
                >
                  <MaterialSummary order={formik.values.order} />
                </Box>
              )}
            </Box>
          </Box>
          <Box sx={{ marginTop: "16px" }}>
            <Typography>PO Details</Typography>
            <DatePicker
              disabled={disabled}
              label="Issue Date"
              value={formik.values.issueDate}
              onChange={(value, context) => {
                formik.setFieldValue("issueDate", value);
              }}
              renderInput={(params) => (
                <TextField
                  size="small"
                  disabled={disabled}
                  fullWidth
                  sx={{ marginTop: "16px" }}
                  {...params}
                />
              )}
            />

            <TextField
              size="small"
              disabled={disabled}
              select
              fullWidth
              sx={{ marginTop: "16px" }}
              label="Delivery Type"
              value={formik.values.deliveryType}
              onChange={(e) => {
                formik.setFieldValue("deliveryType", e.target.value);
              }}
            >
              <MenuItem value={"Delivery"}>Delivery</MenuItem>
              <MenuItem value={"Pickup"}>Pickup</MenuItem>
            </TextField>

            <TextField
              size="small"
              disabled={disabled}
              sx={{ marginTop: "16px" }}
              fullWidth
              label="Ship To"
              value={formik.values.shippingAddress}
              onChange={(e) => {
                formik.setFieldValue("shippingAddress", e.target.value);
              }}
            />

            <TextField
              size="small"
              disabled={disabled}
              sx={{ marginTop: "16px" }}
              fullWidth
              label="Vendor"
              value={formik.values.vendor}
              onChange={(e) => {
                formik.setFieldValue("vendor", e.target.value);
              }}
            />
            <TextField
              size="small"
              disabled={disabled}
              sx={{ marginTop: "16px" }}
              fullWidth
              label="Contact"
              value={formik.values.contact}
              onChange={(e) => {
                formik.setFieldValue("contact", e.target.value);
              }}
            />

            <TextField
              size="small"
              disabled={disabled}
              sx={{ marginTop: "16px" }}
              fullWidth
              multiline
              rows={4}
              label="Notes (Not visible in PO PDF)"
              placeholder="Notes"
              value={formik.values.notes}
              onChange={(e) => {
                formik.setFieldValue("notes", e.target.value);
              }}
            />
          </Box>

          <Grid container spacing={1} sx={{ marginTop: "16px" }}>
            <Grid item sm={12} md={6}>
              <Typography>Painted Flat Sheets</Typography>
              <Box sx={{ padding: "16px" }}>
                <TextField
                  size="small"
                  disabled={disabled}
                  sx={{ marginTop: "16px" }}
                  fullWidth
                  label="Color"
                  value={formik.values.color}
                  onChange={(e) => {
                    formik.setFieldValue("color", e.target.value);
                  }}
                />

                <TextField
                  size="small"
                  disabled={disabled}
                  sx={{ marginTop: "16px" }}
                  fullWidth
                  label="Gauge"
                  value={formik.values.gauge}
                  onChange={(e) => {
                    formik.setFieldValue("gauge", e.target.value);
                  }}
                />

                <TextField
                  size="small"
                  disabled={disabled}
                  sx={{ marginTop: "16px" }}
                  fullWidth
                  label="FS Qty (pc)"
                  type="number"
                  onWheel={(event) => {
                    event.preventDefault();
                  }}
                  onFocus={(e) => e.target.select()}
                  value={formik.values.flatSheetQuantity}
                  onChange={(e) => {
                    formik.setFieldValue("flatSheetQuantity", e.target.value);
                  }}
                />

                <TextField
                  size="small"
                  disabled={disabled}
                  sx={{ marginTop: "16px" }}
                  fullWidth
                  label="FS Size (in)"
                  type="number"
                  onWheel={(event) => {
                    event.preventDefault();
                  }}
                  onFocus={(e) => e.target.select()}
                  value={formik.values.flatSheetSizeInches}
                  onChange={(e) => {
                    formik.setFieldValue("flatSheetSizeInches", e.target.value);
                  }}
                />

                <TextField
                  size="small"
                  disabled={disabled}
                  sx={{ marginTop: "16px" }}
                  fullWidth
                  label="Price Per Flat Sheet"
                  type="number"
                  onWheel={(event) => {
                    event.preventDefault();
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography
                          style={{ color: theme.palette.grey["500"] }}
                        >
                          $
                        </Typography>
                      </InputAdornment>
                    ),
                  }}
                  onFocus={(e) => e.target.select()}
                  value={formik.values.pricePerFlatSheet}
                  onChange={(e) => {
                    formik.setFieldValue("pricePerFlatSheet", e.target.value);
                  }}
                />

                <TextField
                  size="small"
                  disabled={disabled}
                  sx={{ marginTop: "16px" }}
                  fullWidth
                  label="Total Flat Sheet Price"
                  type="number"
                  onWheel={(event) => {
                    event.preventDefault();
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography
                          style={{ color: theme.palette.grey["500"] }}
                        >
                          $
                        </Typography>
                      </InputAdornment>
                    ),
                  }}
                  onFocus={(e) => e.target.select()}
                  value={formik.values.flatSheetTotalPrice}
                  onChange={(e) => {
                    formik.setFieldValue("flatSheetTotalPrice", e.target.value);
                  }}
                />
              </Box>
            </Grid>
            <Grid item sm={12} md={6}>
              <Typography>Galvanized Flat Sheets</Typography>
              <Box sx={{ padding: "16px" }}>
                <TextField
                  size="small"
                  type="number"
                  disabled={disabled}
                  sx={{ marginTop: "16px" }}
                  fullWidth
                  label="Galvanized FS Gauge"
                  value={formik.values.galvanizedFlatSheetGauge}
                  onChange={(e) => {
                    formik.setFieldValue(
                      "galvanizedFlatSheetGauge",
                      e.target.value
                    );
                  }}
                />
                <TextField
                  size="small"
                  disabled={disabled}
                  sx={{ marginTop: "16px" }}
                  fullWidth
                  label="Galvanized FS Qty (pc)"
                  type="number"
                  onWheel={(event) => {
                    event.preventDefault();
                  }}
                  onFocus={(e) => e.target.select()}
                  value={formik.values.galvanizedFlatSheetQuantity}
                  onChange={(e) => {
                    formik.setFieldValue(
                      "galvanizedFlatSheetQuantity",
                      e.target.value
                    );
                  }}
                />

                <TextField
                  size="small"
                  disabled={disabled}
                  sx={{ marginTop: "16px" }}
                  fullWidth
                  label="Galvanized FS Size (in)"
                  type="number"
                  onWheel={(event) => {
                    event.preventDefault();
                  }}
                  onFocus={(e) => e.target.select()}
                  value={formik.values.galvanizedFlatSheetSizeInches}
                  onChange={(e) => {
                    formik.setFieldValue(
                      "galvanizedFlatSheetSizeInches",
                      e.target.value
                    );
                  }}
                />

                <TextField
                  size="small"
                  disabled={disabled}
                  sx={{ marginTop: "16px" }}
                  fullWidth
                  label="Price Per Galvanized Flat Sheet"
                  type="number"
                  onWheel={(event) => {
                    event.preventDefault();
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography
                          style={{ color: theme.palette.grey["500"] }}
                        >
                          $
                        </Typography>
                      </InputAdornment>
                    ),
                  }}
                  onFocus={(e) => e.target.select()}
                  value={formik.values.pricePerGalvanizedFlatSheet}
                  onChange={(e) => {
                    formik.setFieldValue(
                      "pricePerGalvanizedFlatSheet",
                      e.target.value
                    );
                  }}
                />

                <TextField
                  size="small"
                  disabled={disabled}
                  sx={{ marginTop: "16px" }}
                  fullWidth
                  label="Total Galvanized Flat Sheet Price"
                  type="number"
                  onWheel={(event) => {
                    event.preventDefault();
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography
                          style={{ color: theme.palette.grey["500"] }}
                        >
                          $
                        </Typography>
                      </InputAdornment>
                    ),
                  }}
                  onFocus={(e) => e.target.select()}
                  value={formik.values.galvanizedFlatSheetTotalPrice}
                  onChange={(e) => {
                    formik.setFieldValue(
                      "galvanizedFlatSheetTotalPrice",
                      e.target.value
                    );
                  }}
                />
              </Box>
            </Grid>
            <Grid item sm={12} md={6}>
              <Typography>Coil</Typography>
              <Box sx={{ padding: "16px" }}>
                <TextField
                  size="small"
                  disabled={disabled}
                  sx={{ marginTop: "16px" }}
                  fullWidth
                  label="Coil Qty (lf)"
                  type="number"
                  onWheel={(event) => {
                    event.preventDefault();
                  }}
                  onFocus={(e) => e.target.select()}
                  value={formik.values.linealFeetOfCoil}
                  onChange={(e) => {
                    formik.setFieldValue("linealFeetOfCoil", e.target.value);
                  }}
                />

                <TextField
                  size="small"
                  disabled={disabled}
                  sx={{ marginTop: "16px" }}
                  fullWidth
                  label="Coil Qty (SF)"
                  type="number"
                  onWheel={(event) => {
                    event.preventDefault();
                  }}
                  onFocus={(e) => e.target.select()}
                  value={formik.values.squareFeetOfCoil}
                  onChange={(e) => {
                    formik.setFieldValue("squareFeetOfCoil", e.target.value);
                  }}
                />
                <TextField
                  size="small"
                  disabled={disabled}
                  sx={{ marginTop: "16px" }}
                  fullWidth
                  label="Master Coil Size (in)"
                  type="number"
                  onWheel={(event) => {
                    event.preventDefault();
                  }}
                  onFocus={(e) => e.target.select()}
                  value={formik.values.masterCoilWidthInches}
                  onChange={(e) => {
                    formik.setFieldValue(
                      "masterCoilWidthInches",
                      e.target.value
                    );
                  }}
                />
                <TextField
                  size="small"
                  disabled={disabled}
                  sx={{ marginTop: "16px" }}
                  fullWidth
                  label="Coil Width (in)"
                  type="number"
                  onWheel={(event) => {
                    event.preventDefault();
                  }}
                  onFocus={(e) => e.target.select()}
                  value={formik.values.coilWidthInches}
                  onChange={(e) => {
                    formik.setFieldValue("coilWidthInches", e.target.value);
                  }}
                />

                <TextField
                  size="small"
                  disabled={disabled}
                  sx={{ marginTop: "16px" }}
                  fullWidth
                  label="Price Per SF of Coil"
                  type="number"
                  onWheel={(event) => {
                    event.preventDefault();
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography
                          style={{ color: theme.palette.grey["500"] }}
                        >
                          $
                        </Typography>
                      </InputAdornment>
                    ),
                  }}
                  onFocus={(e) => e.target.select()}
                  value={formik.values.pricePerSquareFeetOfCoil}
                  onChange={(e) => {
                    formik.setFieldValue(
                      "pricePerSquareFeetOfCoil",
                      e.target.value
                    );
                  }}
                />

                <TextField
                  size="small"
                  disabled={disabled}
                  sx={{ marginTop: "16px" }}
                  fullWidth
                  label="Total Coil Price"
                  type="number"
                  onWheel={(event) => {
                    event.preventDefault();
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography
                          style={{ color: theme.palette.grey["500"] }}
                        >
                          $
                        </Typography>
                      </InputAdornment>
                    ),
                  }}
                  onFocus={(e) => e.target.select()}
                  value={formik.values.coilTotalPrice}
                  onChange={(e) => {
                    formik.setFieldValue("coilTotalPrice", e.target.value);
                  }}
                />
              </Box>
            </Grid>
            <Grid item sm={12} md={6}>
              <Typography>Coil Drop</Typography>
              <Box sx={{ padding: "16px" }}>
                <TextField
                  size="small"
                  disabled={disabled}
                  sx={{ marginTop: "16px" }}
                  fullWidth
                  label="Coil Drop Size (in)"
                  type="number"
                  onWheel={(event) => {
                    event.preventDefault();
                  }}
                  onFocus={(e) => e.target.select()}
                  value={formik.values.coilDropWidthInches}
                  onChange={(e) => {
                    formik.setFieldValue("coilDropWidthInches", e.target.value);
                  }}
                />
                <TextField
                  size="small"
                  disabled={disabled}
                  sx={{ marginTop: "16px" }}
                  fullWidth
                  label="Coil Drop Qty (LF)"
                  type="number"
                  onWheel={(event) => {
                    event.preventDefault();
                  }}
                  onFocus={(e) => e.target.select()}
                  value={formik.values.linealFeetOfCoilDrop}
                  onChange={(e) => {
                    formik.setFieldValue(
                      "linealFeetOfCoilDrop",
                      e.target.value
                    );
                  }}
                />
                <TextField
                  size="small"
                  disabled={disabled}
                  sx={{ marginTop: "16px" }}
                  fullWidth
                  label="Coil Drop Qty (SF)"
                  type="number"
                  onWheel={(event) => {
                    event.preventDefault();
                  }}
                  onFocus={(e) => e.target.select()}
                  value={formik.values.squareFeetOfCoilDrop}
                  onChange={(e) => {
                    formik.setFieldValue(
                      "squareFeetOfCoilDrop",
                      e.target.value
                    );
                  }}
                />
                <TextField
                  size="small"
                  disabled={disabled}
                  sx={{ marginTop: "16px" }}
                  fullWidth
                  label="Total Coil Drop Price"
                  type="number"
                  onWheel={(event) => {
                    event.preventDefault();
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography
                          style={{ color: theme.palette.grey["500"] }}
                        >
                          $
                        </Typography>
                      </InputAdornment>
                    ),
                  }}
                  onFocus={(e) => e.target.select()}
                  value={formik.values.coilDropTotalPrice}
                  onChange={(e) => {
                    formik.setFieldValue("coilDropTotalPrice", e.target.value);
                  }}
                />
              </Box>
            </Grid>
          </Grid>

          <Box>
            <Box
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
              }}
            >
              <Button
                disabled={disabled}
                onClick={() => {
                  formik.handleSubmit();
                }}
              >
                Submit
              </Button>
            </Box>
          </Box>
        </Box>
      </LocalizationProvider>
    </Box>
  );
};

export default PurchaseOrderForm;
